import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { BALANCE_CURRENCY_QUERY } from '@gig/magic-messages';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
import { toSeconds, parse } from 'iso8601-duration';

var RealityCheckModalComponent = /** @class */ (function (_super) {
    __extends(RealityCheckModalComponent, _super);
    function RealityCheckModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.isLoadingStop = false;
        _this.currency = Currency.EUR;
        return _this;
    }
    RealityCheckModalComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(BALANCE_CURRENCY_QUERY)];
                    case 1:
                        _a.currency = (_b.sent());
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(RealityCheckModalComponent.prototype, "time", {
        get: function () {
            var duration = toSeconds(parse(this.calculatedTime)) / 60;
            return duration * this.elapsedCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RealityCheckModalComponent.prototype, "parseNetPosition", {
        get: function () {
            return Math.round(this.netPosition * 100) / 100;
        },
        enumerable: false,
        configurable: true
    });
    RealityCheckModalComponent.prototype.continueOption = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoading || this.isLoadingStop) {
                            return [2 /*return*/];
                        }
                        this.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, magic.methods.users.continueRealityCheckCoreX({
                                realityCheckId: this.realityCheckId,
                            })];
                    case 2:
                        _a.sent();
                        this.closeModal(true);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        console.error('error', e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    RealityCheckModalComponent.prototype.stopRealityCheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoading || this.isLoadingStop) {
                            return [2 /*return*/];
                        }
                        this.isLoadingStop = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, magic.methods.users.stopRealityCheckCoreX({
                                realityCheckId: this.realityCheckId,
                            })];
                    case 2:
                        _a.sent();
                        this.closeModal(false);
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _a.sent();
                        console.error('error', e_2);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoadingStop = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    RealityCheckModalComponent.prototype.closeModal = function (param) {
        return param;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], RealityCheckModalComponent.prototype, "realityCheckId", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], RealityCheckModalComponent.prototype, "netPosition", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], RealityCheckModalComponent.prototype, "amountSpent", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], RealityCheckModalComponent.prototype, "elapsedCount", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], RealityCheckModalComponent.prototype, "calculatedTime", void 0);
    __decorate([
        Emit('close'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], RealityCheckModalComponent.prototype, "closeModal", null);
    RealityCheckModalComponent = __decorate([
        Component({
            name: 'corex-reality-check-modal',
        })
    ], RealityCheckModalComponent);
    return RealityCheckModalComponent;
}(Mixins(MagicConfigMixin)));

export default RealityCheckModalComponent;
